import {Component, ContentChild, OnInit, TemplateRef} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {AuthService} from '../../../../services/auth.service';
import {SettingsService} from '../../../../services/settings.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-auth-layout',
    templateUrl: './auth-layout.component.html',
    styleUrls: ['./auth-layout.component.scss'],
    standalone: false
})
export class AuthLayoutComponent implements OnInit {

  currentYear: any;
  staffLoginForm: UntypedFormGroup;
  loading = false;
  @ContentChild(TemplateRef, {static : true}) AuthContent: TemplateRef<any>;

  subscription: Subscription = new Subscription();
  constructor(
    private fb: UntypedFormBuilder,
    private route: Router,
    private auth: AuthService,
    public translate: TranslateService,
    private settingService: SettingsService
  ) {
    if (this.auth.alreadyLoggedIn()) {
      this.route.navigate(['/dashboard']).then();
    }
  }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.staffLoginForm = this.fb.group({
      username : [null, [Validators.required, Validators.email]],
      password : [null, [Validators.required, Validators.min(6)]]
    });
  }

  async login() {
    this.loading = true;
    try {
      const tokenData = await this.auth.login(this.staffLoginForm.value);
      this.auth.authRole();
      await this.route.navigate(['/dashboard']);
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  }

  switchLang(lang: string): void {
    this.settingService.switchLang(lang);
  }
}
